import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../../CustomComponents/AccordianContainer";
import CustomDataGrid from "../../CustomComponents/CustomDataGrid";
import CustomDateField from "../../CustomComponents/CustomDateField";
import { CommonShortCutAction } from "../../Store/CommonShortCutsReducer";
import { useRef } from "react";

const VoucherDetails = () => {
  const filterScreen = useSelector((state) => state.cov.filterScreen);

  //Flag used to show/Hide detail screen

  const [voucherStartDate, setVoucherStartDate] = useState(null);
  const [voucherEndDate, setVoucherEndDate] = useState(null);

  const [allVoucher, setAllVoucher] = useState(false);
  const [voucherStartDateEnabled, setVoucherStartDateEnabled] = useState(false);
  const [voucherEndDateEnabled, setVoucherEndDateEnabled] = useState(false);

  //Data Grid storage
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState();
  const [appNum, setAppNum] = useState();

  const dispatch = useDispatch();
  //shortcut key
  const clearRef = useRef(null);
  const searchButtonRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "voucherDetails",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let refList = { clearRef: clearRef, searchButtonRef: searchButtonRef };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      if (charCode === "i") {
        voucherStartDateEnabled && setVoucherStartDate(date);
        voucherEndDateEnabled && setVoucherEndDate(date);
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        voucherStartDateEnabled && setVoucherStartDate(date);
        voucherEndDateEnabled && setVoucherEndDate(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        voucherStartDateEnabled && setVoucherStartDate(date);
        voucherEndDateEnabled && setVoucherEndDate(date);
      } else {
        dispatch(
          CommonShortCutAction.getShortCutValue({
            event: event,
            refs: refList,
            screen: "voucherDetails",
          })
        );
      }
    }
  };

  //Methods
  const fetchButtonHandler = () => {
    getData(appNum, allVoucher);
  };
  const ClearButtonHandler = () => {
    setVoucherStartDate(null);
    setVoucherEndDate(null);
    setAllVoucher(false);
    getData(appNum, true);
  };

  const getData = async (appNum, allVoucherValue) => {
    let queryMap = {};
    try {
      if (allVoucherValue) {
        queryMap = {
          applicationNum: appNum,
          voucherStartDate: null,
          voucherEndDate: null,
          bankGlMap: filterScreen.ledgerAccountsList,
        };
      } else {
        queryMap = {
          applicationNum: appNum,
          voucherStartDate: voucherStartDate,
          voucherEndDate: voucherEndDate,
          bankGlMap: filterScreen.ledgerAccountsList,
        };
      }
      const response = await axios.post(
        "/customerOneView/getVoucherDetailData",
        queryMap
      );
      const responseWithKey = response.data.map((record, index) => {
        return {
          ...record,
          id: index,
          creditAmount: record.creditAmount.toLocaleString("en-IN"),
          debitAmount: record.debitAmount.toLocaleString("en-IN"),
          voucherDate: new Date(record.voucherDate).toLocaleDateString("fr-FR"),
          effectiveDate: new Date(record.effectiveDate).toLocaleDateString(
            "fr-FR"
          ),
          glAccDesc:
            record.glAccDesc === null
              ? filterScreen.glAccountsMap[record.glAcc]
              : record.glAccDesc,
        };
      });
      setRows(responseWithKey);
    } catch {}
  };

  const columnsData = [
    {
      field: "voucherType",
      headerName: "Voucher Type",
      headerAlign: "center",
      flex: 155,
      align: "left",
    },
    {
      field: "voucherNum",
      headerName: "Voucher Number",
      headerAlign: "center",
      flex: 154,
      align: "right",
    },
    {
      field: "voucherDate",
      headerName: "Voucher Date",
      headerAlign: "center",
      flex: 150,
      align: "right",
    },
    {
      field: "glAcc",
      headerName: "GL Account",
      headerAlign: "center",
      flex: 150,
      align: "left",
    },
    {
      field: "glAccDesc",
      headerName: "GL Account Description",
      headerAlign: "center",
      flex: 165,
      align: "left",
    },

    {
      field: "debitAmount",
      headerName: "Debit Amount (₹)",
      headerAlign: "center",
      flex: 130,
      align: "right",
    },
    {
      field: "creditAmount",
      headerName: "Credit Amount (₹)",
      headerAlign: "center",
      flex: 130,
      align: "right",
    },
    {
      field: "voucherDetail",
      headerName: "Voucher Detail",
      headerAlign: "center",
      flex: 140,
      align: "left",
    },
    {
      field: "effectiveDate",
      headerName: "Effective Date",
      headerAlign: "center",
      flex: 143,
      align: "right",
    },
    {
      field: "narration",
      headerName: "Narration",
      headerAlign: "center",
      flex: 150,
      align: "left",
    },
    {
      field: "approvedBy",
      headerName: "Approved By",
      headerAlign: "center",
      flex: 140,
      align: "left",
    },
  ];
  useEffect(() => {
    const appNum = localStorage.getItem("appNum");
    setAppNum(appNum);
    getData(appNum);
  }, []);
  return (
    <>
      <Box>
        <AccordianContainer
          title="Voucher Filter"
          initialOpen={true}
          sx={{
            border: "2px solid #1976d2",
          }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  variant="standard"
                  label="Voucher Start Date"
                  value={voucherStartDate}
                  disabled={allVoucher}
                  onChange={(value) => {
                    setVoucherStartDate(value);
                  }}
                  onOpen={(event) => {
                    setVoucherStartDateEnabled(true);
                    setVoucherEndDateEnabled(false);
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  variant="standard"
                  label="Voucher End Date"
                  value={voucherEndDate}
                  disabled={allVoucher}
                  onChange={(value) => {
                    setVoucherEndDate(value);
                  }}
                  onOpen={(event) => {
                    setVoucherStartDateEnabled(false);
                    setVoucherEndDateEnabled(true);
                  }}
                />
              </Grid>
              {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Voucher Type"
                  label="Voucher Type"
                  required={true}
                  autoCompleteValues={voucherTypeArray}
                  value={voucherType}
                  disabled={allVoucher}
                />
              </Grid> */}
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                xl={3}
                sx={{ display: "flex" }}
              >
                <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={allVoucher}
                        onChange={(event) => {
                          setAllVoucher(event.target.checked);
                        }}
                      ></Checkbox>
                    }
                    label="Fetch All Voucher Details"
                  />
                </Box>
              </Grid>
            </Grid>
            <Box sx={{ marginTop: "8px" }}></Box>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+F" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={fetchButtonHandler}
                  ref={searchButtonRef}
                >
                  Search
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                    fontWeight: "bold",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={ClearButtonHandler}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </AccordianContainer>
        {/* {detailScreenView && ( */}
        <Box>
          <CustomDataGrid
            noDataMessage="No Data."
            noDataOnFilterMessage="No Data on Applied Filter."
            rows={rows}
            onPageSizeChange={(pageSize) => {
              setPageSize(pageSize);
            }}
            columns={columnsData}
            pageSize={10}
            pageSizeOptions={[]}
            gridLazyLoad={() => {}}
            onSortModelChange={() => {}}
          />
        </Box>
        {/* )} */}
      </Box>
    </>
  );
};
export default VoucherDetails;
